<template>
  <div class="space_between_wrapper">
    <div class="middle_box">

      <div class="login-tabs-header">
        <span 
          @click="smsLogin = true"
          :class="{'active_tab': smsLogin}"
        >
          {{ $i18nApi.t('checkout3.loginSms') }}
        </span>
        <span 
          @click="smsLogin = false"
          :class="{'active_tab': !smsLogin}"
        >
          {{ $i18nApi.t('checkout3.loginPassword') }}
        </span>
      </div>

      <div class="login-tabs">

        <div v-if="smsLogin">
          <div class="input_box" v-if="!user.isSmsCodeSent">
            <span :class="{'label': true, 'active': appendedClass === 'input_phone'}">{{ $i18nApi.t('checkout4.number') }}</span>
            <input 
              v-model="phoneNumber" 
              :class="{'validation-filed-border': errors.phone}" 
              type="tel" 
              placeholder="41784XXXXXXX"
              id="tel" 
              @focusin="appendedClass = 'input_phone'" 
              @focusout="appendedClass = ''"
            />
            <span class="helper" v-if="errors.phone && errors.phone.hasOwnProperty('message')">{{ errors.phone.message }}</span>
            <p class="info">{{ $i18nApi.t("checkout3.description") }}</p>
          </div>
          <div class="input_box" v-else>
            <span :class="{'label': true, 'active': appendedClass === 'input_code'}">{{ $i18nApi.t('checkout4.sms') }}</span>
            <input 
              v-model="smsCode" 
              :class="{'validation-filed-border': errors.code}" 
              type="tel" 
              :placeholder="$i18nApi.t('checkout4.sms')" 
              id="code" 
              @focusin="appendedClass = 'input_code'" 
              @focusout="appendedClass = ''"
            />
            <span class="helper" v-if="errors.code && errors.code.hasOwnProperty('message')">{{ errors.code.message }}</span>
          </div>
        </div>

        <div v-if="!smsLogin" class="input_wrapper">
          <div class="input_box">
            <span :class="{'label': true,'active': appendedClass === 'input_email'}">{{ $i18nApi.t('checkout4.username') }}</span>
            <input 
              v-model="username" 
              :class="{'validation-filed-border': errors.username}" 
              type="email" 
              :placeholder="$i18nApi.t('checkout4.username')" 
              id="input_email" 
              @focusin="appendedClass = 'input_email'" 
              @focusout="appendedClass = ''"
            />
            <span class="helper" v-if="errors.username && errors.username.hasOwnProperty('message')">{{ errors.username.message }}</span>
          </div>

          <div class="input_box">
            <span :class="{'label': true,'active': appendedClass === 'password'}">{{ $i18nApi.t('checkout4.password') }}</span>
            <input 
              type="password" 
              v-model="password" 
              id="password"
              :class="{'validation-filed-border': errors.password}"
              :placeholder="$i18nApi.t('checkout4.password')"
              @focusin="appendedClass = 'password'" 
              @focusout="appendedClass = ''"
            />
            <span class="helper" v-if="errors.password && errors.password.hasOwnProperty('message')">{{ errors.password.message }}</span>
          </div>

        </div>
        <span class="helper" v-if="userNotFound && !smsLogin">{{ userNotFound }}</span>

        <div v-if="!smsLogin" class="input_wrapper_reset">
          <div class="reset_tab">
            <a href="#"  
              @click.prevent="showRecovery = !showRecovery"
            >
              {{ $i18nApi.t('checkout4.passwordReset') }}
            </a>
          </div>
          <div class="input_box" v-if="showRecovery" >
            <span :class="{'label': true, 'active': appendedClass === 'resetUsername'}">{{ $i18nApi.t('checkout4.username') }}</span>
            <input 
              v-model="resetUsername" 
              :class="{'validation-filed-border': resetErrors.username}" 
              :placeholder="$i18nApi.t('checkout4.username')"
              type="email" 
              id="resetUsername" 
              @focusin="appendedClass = 'resetUsername'" 
              @focusout="appendedClass = ''"
            />
            <span class="helper" v-if="resetErrors.username">{{ resetErrors.username.message }}</span>
            <a href="#" @click.prevent="forgotPassword">{{ $i18nApi.t('checkout4.passwordResetButton') }}</a>
          </div>
        </div>

        
      </div>
    </div>
  </div>
</template>

<script>
import Login from './Login';
export default Login;
</script>
